import React, { Fragment } from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";
import AppProvider from "../contexts/AppProvider";

import "../styles/App.css";
import "react-toastify/dist/ReactToastify.css";
import { Scrollbars } from "react-custom-scrollbars";

import Print from "./utilities/Print";
import Loading from "./utilities/Loading";
import ServerError from "./utilities/ServerError";
import ApplicationError from "./utilities/ApplicationError";

import Home from "./general/Home";
import Checkout from "./general/Checkout";
import WritingJobs from "./general/WritingJobs";
import BillingDetails from "./general/BillingDetails";
import SelectPlan from "./general/SelectPlan";
import CompleteSteps from "./general/CompleteSteps";
import CompleteStepDetails from "./general/CompleteStepDetails";
import Login from "./auth/Login";
import Logout from "./auth/Logout";
import Intercom from "./auth/Intercom";
import GoogleTag from "./auth/GoogleTag";
import Data from "./auth/register/Data";
import Reset from "./auth/password/Reset";
import EmailVerify from "./auth/email/Verify";
import ResetPassword from "./auth/password/ResetPassword";
import WriterRegister from "./auth/register/WriterRegister";
import EmployerRegister from "./auth/register/EmployerRegister";
import RecoverEmailSent from "./auth/messages/RecoverEmailSent";
import LeftNotifications from "./notifications/LeftNotifications";

import Badges from "./admin/badges/Badges";
import Resource from "./admin/resources/Resource";
import Guides from "./admin/guides/Guide";
import Topics from "./admin/topics/Topics";
import Coupons from "./admin/coupons/Coupons";
import Members from "./admin/members/Members";
import Writers from "./admin/writers/Writers";
import AdminDashboard from "./admin/Dashboard";
import Scrapers from "./admin/scrapers/Scrapers";
import JobTypes from "./admin/jobTypes/JobTypes";
import RejectedReasons from "./admin/rejectedReasons/RejectedReasons";
import Connects from "./admin/connects/Connects";
import Employers from "./admin/employers/Employers";
import JobNiches from "./admin/jobNiches/JobNiches";
import Industries from "./admin/industries/Industries";
import WriterPlans from "./admin/writerPlans/WriterPlans";
import WriterTips from "./admin/writerTips/WriterTips";
import JobDurations from "./admin/jobDurations/JobDurations";
import AppliedBadges from "./admin/adminBadges/AppliedBadges";
import JobCategories from "./admin/jobCategories/JobCategories";
import EmployerPlans from "./admin/employerPlans/EmployerPlans";
import ApprovedBadges from "./admin/adminBadges/ApprovedBadges";
import RejectedBadges from "./admin/adminBadges/RejectedBadges";
import EmailTemplates from "./admin/emailTemplates/EmailTemplates";
import { JobCreate as AdminJobCreate } from "./admin/jobListing/Create";
import { JobUpdate as AdminJobUpdate } from "./admin/jobListing/Update";
import { default as AdminJobListing } from "./admin/jobListing/JobListing";
import ProductPurchases from "./admin/productPurchases/ProductPurchases";
import ConnectsPurchases from "./admin/connectsPurchases/ConnectsPurchases";
import MembershipPayments from "./admin/membershipPayments/MembershipPayments";
import Skills from "./admin/skills/Skills";
import Cms from "./admin/cms/Cms";

import Messages from "./messages/Messages";
import Quiz from "./writer/quiz/Quiz";
import Clients from "./writer/clients/Clients";
import WriterDashboard from "./writer/Dashboard";
import Visitors from "./writer/visitors/Visitors";
import WriterBilling from "./writer/billing/Billing";
import SavedJobs from "./writer/savedJobs/SavedJobs";
import WriterMembership from "./writer/billing/MemeberShip";
import WriterBadges from "./writer/writerBadges/WriterBadges";
import Applications from "./writer/applications/Applications";
import WriterPaymentMethod from "./writer/billing/PaymentMethod";
import MyEranedBadges from "./writer/writerBadges/MyEranedBadges";
import MyBadgeRequest from "./writer/writerBadges/MyBadgeRequest";
import WriterProfileSettings from "./writer/settings/ProfileSettings";
//import WriterAccountSettings from "./writer/settings/AccountSettings";

import EmployerDashboard from "./employer/Dashboard";
import WorkSpace from "./employer/workSpace/WorkSpace";
import EmployerBilling from "./employer/billing/Billing";
import Freelancers from "./employer/freelancers/Freelancers";
import { default as EmployerJobs } from "./employer/jobs/Jobs";
import EmployerPaymentMethod from "./employer/billing/PaymentMethod";
import EmployerProfileSettings from "./employer/settings/ProfileSettings";
import EmployerAccountSettings from "./employer/settings/AccountSettings";
import { JobCreate as EmployerJobCreate } from "./employer/jobListing/Create";
import { JobUpdate as EmployerJobUpdate } from "./employer/jobListing/Update";
import { default as EmployerJobListing } from "./employer/jobListing/JobListing";

import { ResourceCreate as AdminResourceCreate } from "./admin/resources/Create";
import { ResourceUpdate as AdminResourceUpdate } from "./admin/resources/Update";

import { GuideCreate as AdminGuideCreate } from "./admin/guides/Create";
import { GuideUpdate as AdminGuideUpdate } from "./admin/guides/Update";

import { CourseCreate as AdminCourseCreate } from "./admin/courses/Create";
import { CourseUpdate as AdminCourseUpdate } from "./admin/courses/Update";
import { default as AdminCourseListing } from "./admin/courses/CoursesListing";

import { CreateLession as AdminLessionCreate } from "./admin/lessons/Create";
import { LessionUpdate as AdminLessionUpdate } from "./admin/lessons/Update";
import { default as AdminLessionListing } from "./admin/lessons/Listing";

import { CreateChapter as AdminChapterCreate } from "./admin/chapters/Create";
import { UpdateChapter as AdminChapterUpdate } from "./admin/chapters/Update";
import { default as AdminChaptersListing } from "./admin/chapters/Listing";

import WriterAccount from "./writer/account/Account";
import WriterAccountPortfolio from "./writer/account/Portfolio";
import WriterAccountJobs from "./writer/account/Jobs";
import WriterAccountClients from "./writer/account/Clients";
import WriterAccountCourses from "./writer/account/Courses";
import WriterAccountNotifications from "./writer/account/Notifications";
import WriterAccountSettings from "./writer/account/Settings";
import Credits from "./writer/credits/Credits";

import WriterEducation from "./writer/education/Education";

import AppCategories from "./admin/appCategories/AppCategories";

import AppPosts from "./admin/posts/AppPosts";
import AccountDetail from "./general/AccountDetail";
import PersonalDetail from "./general/PersonalDetail";
import SelectInterest from "./general/SelectInterest";
import Preference from "./general/Preference";
import ThankYou from "./general/ThankYou";
import GooglePay from "./payment/GooglePay";
import GooglePaySubscription from "./payment/GooglePaySubscription";

//import AppContext from "../../../contexts/AppContext";

import EmployerAccount from "./employer/account/Account";
import EmployerAccountNotifications from "./employer/account/Notifications";
import EmployerSettings from "./employer/account/Settings";
import { default as EmployerApplicants } from "./employer/applicants/Applicants";
import { default as EmployerWriters } from "./employer/writers/Writers";
import DynamicLists from "./admin/dynamicLinks/DynamicLists.jsx";
import DynamicCreate from "./admin/dynamicLinks/DynamicCreate";
import DynamicUpdate from "./admin/dynamicLinks/DynamicUpdate";

class App extends React.Component {
    render() {
        let before_login_user_state = localStorage.getItem("user_steps");
        return (
            <AppProvider>
                <Fragment>
                    <Loading></Loading>
                    <ApplicationError></ApplicationError>
                    <ServerError></ServerError>
                    <Print></Print>
                    {/* <Scrollbars
                        renderThumbVertical={({ style, ...props }) => (
                            <div
                                {...props}
                                style={{
                                    ...style,
                                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                                    zIndex: 3
                                }}
                            />
                        )}
                        autoHide
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute"
                        }}
                    > */}
                    <div className="App">
                        <Router>
                            <Switch>
                                {/* admin */}
                                <Route
                                    path="/register/data"
                                    component={Data}
                                ></Route>
                                <Route
                                    path="/admin/dashboard"
                                    component={AdminDashboard}
                                ></Route>
                                <Route
                                    path="/admin/writers"
                                    component={Writers}
                                ></Route>
                                <Route
                                    path="/admin/employers"
                                    component={Employers}
                                ></Route>
                                <Route
                                    path="/admin/badges"
                                    component={Badges}
                                ></Route>
                                <Route
                                    path="/admin/resources/create"
                                    component={AdminResourceCreate}
                                ></Route>
                                <Route
                                    path="/admin/resources/update/:id"
                                    component={AdminResourceUpdate}
                                ></Route>
                                <Route
                                    path="/admin/resources"
                                    component={Resource}
                                ></Route>
                                <Route
                                    path="/admin/guides/create"
                                    component={AdminGuideCreate}
                                ></Route>
                                <Route
                                    path="/admin/guides/update/:id"
                                    component={AdminGuideUpdate}
                                ></Route>
                                <Route
                                    path="/admin/guides"
                                    component={Guides}
                                ></Route>
                                <Route
                                    path="/admin/industries"
                                    component={Industries}
                                ></Route>
                                <Route
                                    path="/admin/skills"
                                    component={Skills}
                                ></Route>
                                <Route
                                    path="/admin/jobCategories"
                                    component={JobCategories}
                                ></Route>
                                <Route
                                    path="/admin/appCategories"
                                    component={AppCategories}
                                ></Route>
                                <Route
                                    path="/admin/jobTypes"
                                    component={JobTypes}
                                ></Route>
                                <Route
                                    path="/admin/connects"
                                    component={Connects}
                                ></Route>
                                <Route
                                    path="/admin/jobDurations"
                                    component={JobDurations}
                                ></Route>
                                <Route
                                    path="/admin/jobNiches"
                                    component={JobNiches}
                                ></Route>
                                <Route
                                    path="/admin/scrapers"
                                    component={Scrapers}
                                ></Route>
                                <Route
                                    path="/admin/coupons"
                                    component={Coupons}
                                ></Route>
                                <Route
                                    path="/admin/articles"
                                    component={AppPosts}
                                ></Route>
                                <Route
                                    path="/admin/courses/create"
                                    component={AdminCourseCreate}
                                ></Route>
                                <Route
                                    path="/admin/courses/update/:id"
                                    component={AdminCourseUpdate}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons/create"
                                    component={AdminLessionCreate}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons/update/:lid"
                                    component={AdminLessionUpdate}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons/:lid/chapters/create"
                                    component={AdminChapterCreate}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons/:lid/chapters/update/:cid"
                                    component={AdminChapterUpdate}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons/:lid/chapters"
                                    component={AdminChaptersListing}
                                ></Route>
                                <Route
                                    path="/admin/courses/:id/lessons"
                                    component={AdminLessionListing}
                                ></Route>
                                <Route
                                    path="/admin/courses"
                                    component={AdminCourseListing}
                                ></Route>
                                <Route
                                    path="/admin/writerTips"
                                    component={WriterTips}
                                ></Route>
                                <Route
                                    path="/admin/writerPlans"
                                    component={WriterPlans}
                                ></Route>
                                <Route
                                    path="/admin/employerPlans"
                                    component={EmployerPlans}
                                ></Route>
                                <Route
                                    path="/admin/emailTemplates"
                                    component={EmailTemplates}
                                ></Route>
                                <Route
                                    path="/admin/appliedBadges"
                                    component={AppliedBadges}
                                ></Route>
                                <Route
                                    path="/admin/approvedBadges"
                                    component={ApprovedBadges}
                                ></Route>
                                <Route
                                    path="/admin/rejectedBadges"
                                    component={RejectedBadges}
                                ></Route>
                                <Route
                                    path="/admin/members"
                                    component={Members}
                                ></Route>
                                <Route
                                    path="/admin/job-listings/create"
                                    component={AdminJobCreate}
                                ></Route>
                                <Route
                                    path="/admin/job-listings/update/:id"
                                    component={AdminJobUpdate}
                                ></Route>
                                <Route
                                    path="/admin/job-listings"
                                    component={AdminJobListing}
                                ></Route>
                                <Route
                                    path="/admin/topics"
                                    component={Topics}
                                ></Route>
                                <Route
                                    path="/admin/paymentsFinancials"
                                    component={ProductPurchases}
                                ></Route>
                                <Route
                                    path="/admin/connectsFinancials"
                                    component={ConnectsPurchases}
                                ></Route>
                                <Route
                                    path="/admin/membershipPayments"
                                    component={MembershipPayments}
                                ></Route>
                                <Route
                                    path="/admin/rejectedReasons"
                                    component={RejectedReasons}
                                ></Route>{" "}
                                <Route
                                    path="/admin/messages/:key"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/admin/messages"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/admin/cms"
                                    component={Cms}
                                ></Route>
                                <Route
                                    path="/admin/dynamic-wp-links/create"
                                    component={DynamicCreate}
                                ></Route>
                                <Route
                                    path="/admin/dynamic-wp-links/update/:id"
                                    component={DynamicUpdate}
                                ></Route>
                                <Route
                                    path="/admin/dynamic-wp-links"
                                    component={DynamicLists}
                                ></Route>
                                {/* employer */}
                                <Route
                                    path="/register/employer"
                                    component={EmployerRegister}
                                ></Route>{" "}
                                <Route
                                    path="/employer/messages/:key"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/employer/messages"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/employer/dashboard"
                                    component={EmployerDashboard}
                                ></Route>
                                <Route
                                    path="/employer/profile/settings"
                                    component={EmployerProfileSettings}
                                ></Route>
                                <Route
                                    path="/employer/account/settings"
                                    component={EmployerAccountSettings}
                                ></Route>
                                <Route
                                    path="/employer/jobListing/create"
                                    component={EmployerJobCreate}
                                ></Route>
                                <Route
                                    path="/employer/jobListing/update/:id"
                                    component={EmployerJobUpdate}
                                ></Route>
                                <Route
                                    path="/employer/jobListing/workSpace/:link"
                                    component={WorkSpace}
                                ></Route>
                                <Route
                                    path="/employer/jobs/workSpace/:link"
                                    component={WorkSpace}
                                ></Route>
                                <Route
                                    path="/employer/paymentMethod"
                                    component={EmployerPaymentMethod}
                                ></Route>
                                <Route
                                    path="/employer/workSpace/:link"
                                    component={WorkSpace}
                                ></Route>
                                <Route
                                    path="/employer/jobListing"
                                    component={EmployerJobListing}
                                ></Route>
                                <Route
                                    path="/employer/billing"
                                    component={EmployerBilling}
                                ></Route>
                                <Route
                                    path="/employer/jobs"
                                    component={EmployerJobs}
                                ></Route>
                                <Route
                                    path="/employer/freelancers"
                                    component={Freelancers}
                                ></Route>
                                {/* Employer new UI Start */}
                                <Route
                                    path="/employer/applicants"
                                    component={EmployerApplicants}
                                ></Route>
                                <Route
                                    path="/employer/writers"
                                    component={EmployerWriters}
                                ></Route>
                                <Route
                                    path="/employer/notifications"
                                    component={EmployerAccountNotifications}
                                ></Route>
                                <Route
                                    path="/employer/settings"
                                    component={EmployerSettings}
                                ></Route>
                                <Route
                                    path="/employer/account"
                                    component={EmployerAccount}
                                ></Route>
                                {/* Employer new UI End */}
                                {/* writer */}
                                <Route
                                    path="/writer/messages/:key"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/writer/messages"
                                    component={Messages}
                                ></Route>
                                <Route
                                    path="/register"
                                    component={WriterRegister}
                                ></Route>
                                <Route
                                    path="/register/:token"
                                    component={WriterRegister}
                                ></Route>
                                {/* <Route exact path="/register" render={() => (
                                        (before_login_user_state !== 'account') ?
                                            ((before_login_user_state == 'writing-jobs') ? (<WritingJobs />) : (<CompleteStepDetails />)) :
                                        (<WriterAccount />)
                                    )} /> */}
                                <Route
                                    path="/writer/dashboard"
                                    component={WriterDashboard}
                                ></Route>
                                <Route
                                    path="/writer/profile/settings"
                                    component={WriterProfileSettings}
                                ></Route>
                                <Route
                                    path="/writer/account/settings"
                                    component={WriterAccountSettings}
                                ></Route>
                                <Route
                                    path="/writer/MyEranedBadges"
                                    component={MyEranedBadges}
                                ></Route>
                                <Route
                                    path="/writer/MyBadgeRequest"
                                    component={MyBadgeRequest}
                                ></Route>
                                <Route
                                    path="/writer/savedJobs"
                                    component={SavedJobs}
                                ></Route>
                                <Route
                                    path="/writer/quiz"
                                    component={Quiz}
                                ></Route>
                                <Route
                                    path="/writer/clients"
                                    component={Clients}
                                ></Route>
                                {/* others */}
                                <Route
                                    path="/email/recoverSent"
                                    component={RecoverEmailSent}
                                ></Route>
                                <Route
                                    path="/password/reset/:token"
                                    component={ResetPassword}
                                ></Route>
                                <Route
                                    path="/email/verify/:token"
                                    component={EmailVerify}
                                ></Route>
                                <Route
                                    path="/password/reset"
                                    component={Reset}
                                ></Route>
                                <Route
                                    path="/logout"
                                    component={Logout}
                                ></Route>
                                <Route
                                    path="/account/achievements"
                                    component={WriterBadges}
                                ></Route>
                                <Route
                                    path="/account/portfolio/visitors"
                                    component={Visitors}
                                ></Route>
                                <Route
                                    path="/account/portfolio"
                                    component={WriterAccountPortfolio}
                                ></Route>
                                <Route
                                    path="/account/jobs/applications"
                                    component={Applications}
                                ></Route>
                                <Route
                                    path="/account/jobs"
                                    component={WriterAccountJobs}
                                ></Route>
                                <Route
                                    path="/account/clients"
                                    component={WriterAccountClients}
                                ></Route>
                                <Route
                                    path="/account/courses"
                                    component={WriterAccountCourses}
                                ></Route>
                                <Route
                                    path="/account/notifications"
                                    component={WriterAccountNotifications}
                                ></Route>
                                <Route
                                    path="/account/settings/membership"
                                    component={WriterMembership}
                                ></Route>
                                <Route
                                    path="/account/settings/credits"
                                    component={Credits}
                                ></Route>
                                <Route
                                    path="/account/settings/payment-methods"
                                    component={WriterPaymentMethod}
                                ></Route>
                                <Route
                                    path="/account/settings/billing-history"
                                    component={WriterBilling}
                                ></Route>
                                <Route
                                    path="/account/settings"
                                    component={WriterAccountSettings}
                                ></Route>
                                <Route
                                    path="/account"
                                    component={WriterAccount}
                                ></Route>
                                {/* <Route exact path="/account" render={() => (
                                        (before_login_user_state !== 'account') ?
                                            ((before_login_user_state == 'writing-jobs') ? (<WritingJobs />) : (<CompleteStepDetails />)) :
                                        (<WriterAccount />)
                                    )} /> */}
                                <Route
                                    path="/education"
                                    component={WriterEducation}
                                ></Route>
                                <Route
                                    path="/process/finish/:token"
                                    component={ThankYou}
                                ></Route>
                                <Route
                                    path="/process/preference/:token"
                                    component={Preference}
                                ></Route>
                                <Route
                                    path="/process/select-interests/:token"
                                    component={SelectInterest}
                                ></Route>
                                <Route
                                    path="/process/personal-details/:token"
                                    component={PersonalDetail}
                                ></Route>
                                <Route
                                    path="/process/account-details/:token"
                                    component={AccountDetail}
                                ></Route>
                                <Route
                                    path="/process/checkout"
                                    component={Checkout}
                                ></Route>
                                <Route
                                    path="/process/writingjobs"
                                    component={WritingJobs}
                                ></Route>
                                <Route
                                    path="/process/billing"
                                    component={BillingDetails}
                                ></Route>
                                <Route
                                    path="/process/select-plan"
                                    component={SelectPlan}
                                ></Route>
                                {/* <Route path="/process/step3" component={CompleteSteps}></Route> */}
                                <Route
                                    path="/process/step3"
                                    component={CompleteStepDetails}
                                ></Route>
                                <Route
                                    path="/googlePay"
                                    component={GooglePay}
                                ></Route>
                                <Route
                                    path="/googlePaySubscription"
                                    component={GooglePaySubscription}
                                ></Route>
                                <Route path="/" component={Home}></Route>
                            </Switch>
                            {/* <Route
                                    component={Intercom}
                                ></Route> */}
                        </Router>
                    </div>
                    {/* </Scrollbars> */}

                    <GoogleTag></GoogleTag>
                    <LeftNotifications></LeftNotifications>
                </Fragment>
            </AppProvider>
        );
    }
}
export default App;



// WEBPACK FOOTER //
// ./src/components/App.js